import { createFileRoute } from "@tanstack/react-router";
import { getMetricsAvailable } from "api-client";

import { CoachLibraryMetricsPage } from "src/pages/CoachLibraryMetricsPage";

export const Route = createFileRoute("/_auth/_admin/admin/metrics/")({
  component: RouteComponent,
  ssr: true,
  shouldReload: false,
  async loader() {
    const metrics = await getMetricsAvailable().then((res) => {
      return res.data.data;
    });
    return { data: { metrics } };
  },
});

function RouteComponent() {
  return <CoachLibraryMetricsPage />;
}
